var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsAuthKeyIcon = function SvgDsAuthKeyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373D4D",
    fillRule: "evenodd",
    d: "M9.833 5.191a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#373D4D",
    fillRule: "evenodd",
    d: "M7.535 1.597a5 5 0 1 1 1.422 9.08l-.262.262a2 2 0 0 1-1.414.586h-.114v.666a1.333 1.333 0 0 1-1.334 1.334h-.666v.666a1.333 1.333 0 0 1-1.334 1.334h-2A1.334 1.334 0 0 1 .5 14.19v-1.448a2 2 0 0 1 .586-1.414l4.261-4.26a5 5 0 0 1 2.188-5.472m3.069.592A3.667 3.667 0 0 0 6.73 7.04a.67.67 0 0 1-.159.69L2.03 12.273a.67.67 0 0 0-.196.471v1.448h2v-.666a1.333 1.333 0 0 1 1.334-1.334h.666v-.666a1.333 1.333 0 0 1 1.334-1.334h.114c.177 0 .347-.07.472-.195l.542-.543c.181-.18.45-.242.691-.158a3.667 3.667 0 1 0 1.618-7.106",
    clipRule: "evenodd"
  })));
};
export default SvgDsAuthKeyIcon;